<div class="image-player-container" *ngIf="siteTwin && !fullScreen">
  <div class="row">
    <div class="col-sm-12" *ngIf="mode == 0">
      <smart-image [showMetaData]="false" [src]="this.fire.camera?.manualCameraLatestUrl != null && this.fire.camera?.manualCameraLatestUrl.trim() !== '' ? this.fire.camera?.manualCameraLatestUrl : this.fire.camera?.images[0]?.latestImageUrl" [showZones]="showZones" [zones]="_zones"></smart-image>
    </div>
    <div class="col-sm-12" *ngIf="mode == 2">
      <!--<img #livestream [src]="streamUrl" width="1280" height="960" alt="Axis Camera Stream">-->
      <img *ngIf="mode == 2 && liveStreaming && streamUrl" class="animate__animated animate__fadeIn" #livestream [src]="streamUrl" alt="Axis Camera Stream">
      <img *ngIf="mode == 2 && liveStreaming && !streamUrl" class="animate__animated animate__fadeIn" #livestream [src]="'/assets/images/connecting.png'" alt="Axis Camera Stream">
      <div class="progress">
        <div class="progress-bar" style="width: {{timeout}}%"></div>
      </div>
    </div>
    <div class="col-sm-12 pt-2" *ngIf="this.fire.camera?.canStream">
      <a *ngIf="mode == 0 && this.fire.camera?.canStream" (click)="changeMode(2)" data-toggle="card-expand" style="cursor: pointer;" title="Enable Live Stream" 
        class="btn btn-theme text-inverse text-decoration-none">
        <i [ngClass]="{'bi-camera-video':!liveStreaming,'bi-camera-video-fill':liveStreaming}" class="bi"></i>
        <span> Enable Live Stream</span>
      </a>
      <a *ngIf="mode == 2 && this.fire.camera?.canStream" (click)="changeMode(0)" data-toggle="card-expand" style="cursor: pointer;" title="Enable Live Stream" 
        class="btn btn-theme text-inverse text-decoration-none">
        <i [ngClass]="{'bi-camera-video':!liveStreaming,'bi-camera-video-fill':liveStreaming}" class="bi"></i>
        <span> Disable Live Stream</span>
      </a>
    </div>
    <div class="col-sm-12" *ngIf="streamUrl && liveStreaming">
      <app-camera-controller [siteUri]="this.fire.camera?.siteUri"></app-camera-controller>              
    </div>
  </div>
</div>

<div class="image-player-container" *ngIf="siteTwin && fullScreen">
  <div class="fullscreen" *ngIf="selectedImageIndex >= 0 && objects">
    <div>
      <div class="image-container image-player-inner" *ngIf="objects[selectedImageIndex]?.latestValue == null">
        Select Image {{objects[selectedImageIndex]?.offline}}
      </div>
      <div class="image-container" *ngIf="objects[selectedImageIndex]?.latestValue && !offline">
        <smart-image 
            [src]="objects[selectedImageIndex]?.latestImageUrl" 
            [enableFeatureSelection]="enableFireSelection" 
            [showZones]="showZones" 
            [zones]="_zones" [aspectRatio]="'16:9'" 
            [isLoaded]="siteTwin != null" 
            [showLineAt]="showLineAt"
            [overlayConfig]="getSelectedImageOverlay(selectedImageIndex)" 
            (pointerEvent)="pointerEvent($event)">
        </smart-image>
      </div>
      <div class="image-container" *ngIf="objects[selectedImageIndex]?.latestValue == null || offline">
        <smart-image [src]="'/assets/images/offline.jpeg'" [enableFeatureSelection]="false" [aspectRatio]="'16:9'" [isLoaded]="siteTwin != null" [overlayConfig]="getSelectedImageOverlay(selectedImageIndex)" (pointerEvent)="pointerEvent($event)"></smart-image>
      </div>
      <div class="panorama">
        <table class="bearing">
          <tr>
            <td *ngFor="let ts of objects; index as i">
                {{ts.bearing}}
            </td>
          </tr>
          <tr>
            <td *ngFor="let ts of objects; index as i" (click)="showImage(i)" [ngClass]="{selected:i == selectedImageIndex}">
              <img *ngIf="!offline" [src]="ts.latestImageUrl"/>
              <img *ngIf="offline" [src]="'/assets/images/offline.jpeg'"/>              
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

</div>

